import { GridColDef } from '@mui/x-data-grid-pro'
import { isObject } from '@mui/x-data-grid/internals'

export const columns: GridColDef[] = [
  // {
  //   field: 'id',
  //   headerName: 'ID',
  //   width: 90,
  //   hide: true,
  //   headerClassName: 'super-app-theme--header',
  // },
  {
    field: 'label',
    headerName: 'Label',
    editable: false,
    minWidth: 250,
    flex: 1,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'budgetedHours',
    headerName: 'Budgeted Hours',
    editable: false,
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'totalTimeWorkedFormatted',
    headerName: 'Hours Worked',
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'remainingTimeFormatted',
    headerName: 'Remaining Hours',
    width: 150,
    headerClassName: 'super-app-theme--header',
  },
]
